import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Credentials } from "auth";
import { State } from "redux/state";

import { DeletePendingUserProps } from "@xapp/stentor-api-client/dist/api/orgs/orgId/users/pending/email/inviteId/InviteId";

export type DeletePendingUser = "DELETE_PENDING_USER";
export const DELETE_PENDING_USER: DeletePendingUser = "DELETE_PENDING_USER";
export type DeletePendingUserEnd = "DELETE_PENDING_USER_END";
export const DELETE_PENDING_USER_END: DeletePendingUserEnd = "DELETE_PENDING_USER_END";

export interface DeletePendingUserAction extends Action {
    payload: {
        credentials: Credentials;
        organizationId: string;
        props: DeletePendingUserProps;
    };
    type: DeletePendingUser;
}

export interface DeletePendingUserEndAction extends Action {
    payload: {
        error?: Error;
        organizationId: string;
        props: DeletePendingUserProps;
    };
    type: DeletePendingUserEnd;
}

export function deletePendingUser(
    organizationId: string,
    props: DeletePendingUserProps
): ThunkAction<void, State, undefined, DeletePendingUserAction> {
    return (dispatch: Dispatch<DeletePendingUserAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(deletePendingUserWithCredentials(organizationId, props, credentials));
    };
}

function deletePendingUserWithCredentials(
    organizationId: string,
    props: DeletePendingUserProps,
    credentials: Credentials
): DeletePendingUserAction {
    return {
        payload: {
            credentials,
            organizationId,
            props
        },
        type: DELETE_PENDING_USER
    };
}

export function deletePendingUserEnd(
    error: Error,
    organizationId: string,
    props: DeletePendingUserProps
): DeletePendingUserEndAction {
    return {
        payload: {
            error,
            organizationId,
            props
        },
        type: DELETE_PENDING_USER_END
    };
}
